// import React, { useState, useEffect } from "react";
// import { Modal, Button, List, Form, Input, Empty, Tooltip, message } from "antd";
// import {
//     BookOutlined,
//     EditOutlined,
//     DeleteOutlined,
//     PlusOutlined,
//     ExclamationCircleOutlined,
//     SaveOutlined,
// } from "@ant-design/icons";
// import { Editor } from "@tinymce/tinymce-react";
// import courseService from "../../../services/course.service";
// import SecureContent from "../../../common/SecureContent";

// const ResourceManager = ({ visible, subject, onClose, onSaved }) => {
//     const [resources, setResources] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // Ajout
//     const [isAdding, setIsAdding] = useState(false);
//     const [newContent, setNewContent] = useState("");

//     // Édition
//     const [isEditing, setIsEditing] = useState(false);
//     const [editingResource, setEditingResource] = useState(null);
//     const [editTitle, setEditTitle] = useState("");
//     const [editContent, setEditContent] = useState("");
//     const [savingEdit, setSavingEdit] = useState(false);

//     useEffect(() => {
//         if (visible && subject?.id) {
//             loadResources();
//         }
//     }, [visible, subject?.id]);

//     const loadResources = async () => {
//         if (!subject?.id) return;
//         setLoading(true);
//         try {
//             const data = await courseService.getResourcesBySubject(subject.id);
//             setResources(data || []);
//         } catch (error) {
//             console.error("Erreur chargement ressources:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ========== AJOUTER ==========
//     const handleAdd = async (values) => {
//         try {
//             await courseService.addResourceToSubject(subject.id, {
//                 title: values.title,
//                 content: newContent,
//             });
//             message.success("Ressource ajoutée !");
//             setIsAdding(false);
//             setNewContent("");
//             await loadResources();
//             onSaved?.();
//         } catch (error) {
//             message.error("Erreur lors de l'ajout de la ressource.");
//         }
//     };

//     // ========== MODIFIER ==========
//     const openEdit = (resource) => {
//         setEditingResource(resource);
//         setEditTitle(resource.title || "");
//         setEditContent(resource.content || "");
//         setIsEditing(true);
//     };

//     const handleUpdate = async () => {
//         if (!editingResource?.id || !editTitle.trim()) return;
//         setSavingEdit(true);
//         try {
//             await courseService.updateResource(editingResource.id, {
//                 title: editTitle,
//                 content: editContent,
//             });
//             message.success("Ressource modifiée !");
//             setIsEditing(false);
//             setEditingResource(null);
//             await loadResources();
//             onSaved?.();
//         } catch (error) {
//             message.error("Erreur lors de la modification.");
//         } finally {
//             setSavingEdit(false);
//         }
//     };

//     // ========== SUPPRIMER ==========
//     const handleDelete = (resourceId) => {
//         Modal.confirm({
//             title: "Confirmer la suppression",
//             icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
//             content: "Êtes-vous sûr de vouloir supprimer cette ressource ?",
//             okText: "Supprimer",
//             okType: "danger",
//             cancelText: "Annuler",
//             onOk: async () => {
//                 try {
//                     await courseService.deleteResource(resourceId);
//                     message.success("Ressource supprimée !");
//                     await loadResources();
//                     onSaved?.();
//                 } catch (error) {
//                     message.error("Erreur lors de la suppression.");
//                 }
//             },
//         });
//     };

//     const handleClose = () => {
//         setIsAdding(false);
//         setIsEditing(false);
//         setEditingResource(null);
//         onClose?.();
//     };

//     return (
//         <>
//             {/* Modal principal */}
//             <Modal
//                 open={visible}
//                 title={`Ressources : ${subject?.title || ""}`}
//                 footer={null}
//                 width="70%"
//                 onCancel={handleClose}
//             >
//                 <List
//                     loading={loading}
//                     dataSource={resources}
//                     locale={{ emptyText: <Empty description="Aucune ressource" /> }}
//                     renderItem={(item) => (
//                         <List.Item
//                             actions={[
//                                 <Tooltip title="Modifier" key="edit">
//                                     <Button
//                                         type="primary"
//                                         size="small"
//                                         icon={<EditOutlined />}
//                                         onClick={() => openEdit(item)}
//                                         style={{ borderRadius: "6px" }}
//                                     >
//                                         Modifier
//                                     </Button>
//                                 </Tooltip>,
//                                 <Tooltip title="Supprimer" key="delete">
//                                     <Button
//                                         danger
//                                         size="small"
//                                         icon={<DeleteOutlined />}
//                                         onClick={() => handleDelete(item.id)}
//                                         style={{ borderRadius: "6px" }}
//                                     >
//                                         Supprimer
//                                     </Button>
//                                 </Tooltip>,
//                             ]}
//                         >
//                             <List.Item.Meta
//                                 avatar={<BookOutlined style={{ fontSize: "20px", color: "#722ed1" }} />}
//                                 title={item.title}
//                                 description={<SecureContent html={item.content} />}
//                             />
//                         </List.Item>
//                     )}
//                 />

//                 <div style={{ textAlign: "center", marginTop: "20px" }}>
//                     <Button
//                         type="primary"
//                         icon={<PlusOutlined />}
//                         onClick={() => setIsAdding(true)}
//                         style={{ background: "#722ed1", border: "none", borderRadius: "8px" }}
//                     >
//                         Ajouter une ressource
//                     </Button>
//                 </div>
//             </Modal>

//             {/* Modal Ajouter */}
//             <Modal
//                 open={isAdding}
//                 title="Nouvelle ressource"
//                 footer={null}
//                 onCancel={() => { setIsAdding(false); setNewContent(""); }}
//                 width="60%"
//                 destroyOnClose
//             >
//                 <Form layout="vertical" onFinish={handleAdd}>
//                     <Form.Item name="title" label="Titre" rules={[{ required: true, message: "Le titre est requis" }]}>
//                         <Input placeholder="Titre de la ressource" />
//                     </Form.Item>
//                     <Form.Item label="Contenu">
//                         <Editor
//                             apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                             onEditorChange={(v) => setNewContent(v)}
//                             init={{ height: 300, menubar: false }}
//                         />
//                     </Form.Item>
//                     <Button type="primary" htmlType="submit" block style={{ borderRadius: "8px" }}>
//                         Ajouter
//                     </Button>
//                 </Form>
//             </Modal>

//             {/* Modal Modifier */}
//             <Modal
//                 open={isEditing}
//                 title={`Modifier : ${editingResource?.title || ""}`}
//                 footer={null}
//                 onCancel={() => { setIsEditing(false); setEditingResource(null); }}
//                 width="60%"
//                 destroyOnClose
//             >
//                 <Form layout="vertical">
//                     <Form.Item label="Titre" required>
//                         <Input
//                             value={editTitle}
//                             onChange={(e) => setEditTitle(e.target.value)}
//                             placeholder="Titre de la ressource"
//                         />
//                     </Form.Item>
//                     <Form.Item label="Contenu">
//                         <Editor
//                             apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                             initialValue={editingResource?.content || ""}
//                             onEditorChange={(v) => setEditContent(v)}
//                             init={{ height: 300, menubar: false }}
//                         />
//                     </Form.Item>
//                     <Button
//                         type="primary"
//                         icon={<SaveOutlined />}
//                         block
//                         loading={savingEdit}
//                         onClick={handleUpdate}
//                         disabled={!editTitle.trim()}
//                         style={{ borderRadius: "8px" }}
//                     >
//                         Enregistrer les modifications
//                     </Button>
//                 </Form>
//             </Modal>
//         </>
//     );
// };

// export default ResourceManager;


import React, { useState, useEffect } from "react";
import { Modal, Button, List, Form, Input, Empty, Tooltip, message, Tag, Space, Switch } from "antd";
import {
    BookOutlined,
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    SaveOutlined,
    LinkOutlined,
    GlobalOutlined,
    FileTextOutlined,
    CopyOutlined,
} from "@ant-design/icons";
import { Editor } from "@tinymce/tinymce-react";
import courseService from "../../../services/course.service";
import SecureContent from "../../../common/SecureContent";

const ResourceManager = ({ visible, subject, onClose, onSaved }) => {
    const [resources, setResources] = useState([]);
    const [loading, setLoading] = useState(false);

    // Ajout
    const [isAdding, setIsAdding] = useState(false);
    const [newContent, setNewContent] = useState("");
    const [newLink, setNewLink] = useState("");
    const [showEditor, setShowEditor] = useState(false);
    const [addForm] = Form.useForm();

    // Édition
    const [isEditing, setIsEditing] = useState(false);
    const [editingResource, setEditingResource] = useState(null);
    const [editTitle, setEditTitle] = useState("");
    const [editContent, setEditContent] = useState("");
    const [editLink, setEditLink] = useState("");
    const [showEditEditor, setShowEditEditor] = useState(false);
    const [savingEdit, setSavingEdit] = useState(false);

    useEffect(() => {
        if (visible && subject?.id) {
            loadResources();
        }
    }, [visible, subject?.id]);

    const loadResources = async () => {
        if (!subject?.id) return;
        setLoading(true);
        try {
            const data = await courseService.getResourcesBySubject(subject.id);
            setResources(data || []);
        } catch (error) {
            console.error("Erreur chargement ressources:", error);
        } finally {
            setLoading(false);
        }
    };

    // ========== Utilitaire : construire le contenu final ==========
    const buildContent = (link, richContent) => {
        let finalContent = "";

        // Si un lien est fourni, on l'intègre dans le contenu en tant que lien hypertexte
        if (link && link.trim()) {
            finalContent += `<p><a href="${link.trim()}" target="_blank" rel="noopener noreferrer">${link.trim()}</a></p>`;
        }

        // Ajouter le contenu riche s'il existe
        if (richContent && richContent.trim()) {
            finalContent += richContent;
        }

        return finalContent;
    };

    // ========== Utilitaire : extraire le lien du contenu ==========
    const extractLinkFromContent = (content) => {
        if (!content) return { link: "", cleanContent: "" };

        // Chercher un lien <a href="..."> dans le contenu
        const linkRegex = /<p>\s*<a\s+href="([^"]+)"[^>]*>[^<]*<\/a>\s*<\/p>/i;
        const match = content.match(linkRegex);

        if (match) {
            const link = match[1];
            const cleanContent = content.replace(match[0], "").trim();
            return { link, cleanContent };
        }

        // Chercher aussi les URLs brutes dans le contenu
        const urlRegex = /<p>\s*(https?:\/\/[^\s<]+)\s*<\/p>/i;
        const urlMatch = content.match(urlRegex);

        if (urlMatch) {
            const link = urlMatch[1];
            const cleanContent = content.replace(urlMatch[0], "").trim();
            return { link, cleanContent };
        }

        return { link: "", cleanContent: content };
    };

    // ========== AJOUTER ==========
    const handleAdd = async (values) => {
        try {
            const finalContent = buildContent(newLink, showEditor ? newContent : "");

            await courseService.addResourceToSubject(subject.id, {
                title: values.title,
                content: finalContent,
            });
            message.success("Ressource ajoutée !");
            resetAddForm();
            await loadResources();
            onSaved?.();
        } catch (error) {
            message.error("Erreur lors de l'ajout de la ressource.");
        }
    };

    const resetAddForm = () => {
        setIsAdding(false);
        setNewContent("");
        setNewLink("");
        setShowEditor(false);
        addForm.resetFields();
    };

    // ========== MODIFIER ==========
    const openEdit = (resource) => {
        const { link, cleanContent } = extractLinkFromContent(resource.content);
        setEditingResource(resource);
        setEditTitle(resource.title || "");
        setEditLink(link);
        setEditContent(cleanContent);
        setShowEditEditor(!!cleanContent && cleanContent !== "");
        setIsEditing(true);
    };

    const handleUpdate = async () => {
        if (!editingResource?.id || !editTitle.trim()) return;
        setSavingEdit(true);
        try {
            const finalContent = buildContent(editLink, showEditEditor ? editContent : "");

            await courseService.updateResource(editingResource.id, {
                title: editTitle,
                content: finalContent,
            });
            message.success("Ressource modifiée !");
            setIsEditing(false);
            setEditingResource(null);
            await loadResources();
            onSaved?.();
        } catch (error) {
            message.error("Erreur lors de la modification.");
        } finally {
            setSavingEdit(false);
        }
    };

    // ========== SUPPRIMER ==========
    const handleDelete = (resourceId) => {
        Modal.confirm({
            title: "Confirmer la suppression",
            icon: <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />,
            content: "Êtes-vous sûr de vouloir supprimer cette ressource ?",
            okText: "Supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                try {
                    await courseService.deleteResource(resourceId);
                    message.success("Ressource supprimée !");
                    await loadResources();
                    onSaved?.();
                } catch (error) {
                    message.error("Erreur lors de la suppression.");
                }
            },
        });
    };

    const handleClose = () => {
        setIsAdding(false);
        setIsEditing(false);
        setEditingResource(null);
        onClose?.();
    };

    // ========== Copier le lien ==========
    const copyLink = (content) => {
        const { link } = extractLinkFromContent(content);
        if (link) {
            navigator.clipboard.writeText(link);
            message.success("Lien copié !");
        }
    };

    // ========== STYLES ==========
    const styles = {
        resourceItem: {
            padding: "16px",
            margin: "8px 0",
            background: "#fafafa",
            borderRadius: "10px",
            border: "1px solid #f0f0f0",
            transition: "all 0.2s",
        },
        resourceHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "8px",
        },
        resourceTitle: {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flex: 1,
        },
        titleText: {
            fontSize: "15px",
            fontWeight: 600,
            color: "#262626",
        },
        linkTag: {
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            background: "#f0f5ff",
            color: "#1890ff",
            border: "1px solid #d6e4ff",
            borderRadius: "6px",
            padding: "2px 8px",
            fontSize: "11px",
            cursor: "pointer",
            maxWidth: "300px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        linkInput: {
            borderRadius: "8px",
        },
        editorToggle: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "16px",
            padding: "8px 12px",
            background: "#f5f5f5",
            borderRadius: "8px",
            fontSize: "13px",
            color: "#595959",
        },
        actions: {
            display: "flex",
            gap: "6px",
        },
    };

    return (
        <>
            {/* ========== Modal principal ========== */}
            <Modal
                open={visible}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <BookOutlined />
                        Ressources : {subject?.title || ""}
                    </span>
                }
                footer={null}
                width="70%"
                onCancel={handleClose}
            >
                {loading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <span>Chargement...</span>
                    </div>
                ) : resources.length === 0 ? (
                    <Empty description="Aucune ressource" style={{ padding: "40px 0" }} />
                ) : (
                    <div>
                        {resources.map((item) => {
                            const { link, cleanContent } = extractLinkFromContent(item.content);
                            return (
                                <div key={item.id} style={styles.resourceItem}>
                                    <div style={styles.resourceHeader}>
                                        <div style={styles.resourceTitle}>
                                            <BookOutlined style={{ fontSize: "18px", color: "#722ed1" }} />
                                            <span style={styles.titleText}>{item.title}</span>
                                            {link && (
                                                <Tooltip title={link}>
                                                    <a
                                                        href={link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={styles.linkTag}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <LinkOutlined />
                                                        Ouvrir le lien
                                                    </a>
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div style={styles.actions}>
                                            {link && (
                                                <Tooltip title="Copier le lien">
                                                    <Button
                                                        size="small"
                                                        icon={<CopyOutlined />}
                                                        onClick={() => copyLink(item.content)}
                                                        style={{ borderRadius: "6px" }}
                                                    />
                                                </Tooltip>
                                            )}
                                            <Button
                                                type="primary"
                                                size="small"
                                                icon={<EditOutlined />}
                                                onClick={() => openEdit(item)}
                                                style={{ borderRadius: "6px" }}
                                            >
                                                Modifier
                                            </Button>
                                            <Button
                                                danger
                                                size="small"
                                                icon={<DeleteOutlined />}
                                                onClick={() => handleDelete(item.id)}
                                                style={{ borderRadius: "6px" }}
                                            >
                                                Supprimer
                                            </Button>
                                        </div>
                                    </div>

                                    {/* Afficher le contenu riche s'il y en a (hors lien) */}
                                    {cleanContent && cleanContent.trim() && (
                                        <div style={{ marginTop: "8px", paddingLeft: "28px" }}>
                                            <SecureContent html={cleanContent} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setIsAdding(true)}
                        style={{
                            background: "linear-gradient(135deg, #722ed1 0%, #531dab 100%)",
                            border: "none",
                            borderRadius: "8px",
                            height: "40px",
                            paddingInline: "24px",
                        }}
                    >
                        Ajouter une ressource
                    </Button>
                </div>
            </Modal>

            {/* ========== Modal Ajouter ========== */}
            <Modal
                open={isAdding}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <PlusOutlined />
                        Nouvelle ressource
                    </span>
                }
                footer={null}
                onCancel={resetAddForm}
                width="60%"
                destroyOnClose
            >
                <Form form={addForm} layout="vertical" onFinish={handleAdd}>
                    <Form.Item
                        name="title"
                        label="Titre de la ressource"
                        rules={[{ required: true, message: "Le titre est requis" }]}
                    >
                        <Input
                            prefix={<FileTextOutlined style={{ color: "#bfbfbf" }} />}
                            placeholder="Ex: Documentation officielle, Tutoriel vidéo..."
                            style={styles.linkInput}
                        />
                    </Form.Item>

                    <Form.Item label={
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <LinkOutlined style={{ color: "#1890ff" }} />
                            Lien (URL)
                        </span>
                    }>
                        <Input
                            value={newLink}
                            onChange={(e) => setNewLink(e.target.value)}
                            placeholder="https://exemple.com/documentation"
                            style={styles.linkInput}
                            prefix={<GlobalOutlined style={{ color: "#bfbfbf" }} />}
                        />
                        <div style={{ fontSize: "12px", color: "#8c8c8c", marginTop: "4px" }}>
                            Ce lien sera affiché comme titre cliquable côté étudiant
                        </div>
                    </Form.Item>

                    <div style={styles.editorToggle}>
                        <Switch
                            size="small"
                            checked={showEditor}
                            onChange={setShowEditor}
                        />
                        <span>Ajouter du contenu supplémentaire (description, notes...)</span>
                    </div>

                    {showEditor && (
                        <Form.Item label="Contenu supplémentaire">
                            <Editor
                                apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                onEditorChange={(v) => setNewContent(v)}
                                init={{
                                    height: 250,
                                    menubar: false,
                                    plugins: "link autolink lists",
                                    toolbar: "undo redo | bold italic | link | bullist numlist",
                                    link_default_target: "_blank",
                                }}
                            />
                        </Form.Item>
                    )}

                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        icon={<PlusOutlined />}
                        style={{
                            borderRadius: "8px",
                            height: "42px",
                            background: "linear-gradient(135deg, #722ed1 0%, #531dab 100%)",
                            border: "none",
                        }}
                    >
                        Ajouter la ressource
                    </Button>
                </Form>
            </Modal>

            {/* ========== Modal Modifier ========== */}
            <Modal
                open={isEditing}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <EditOutlined />
                        Modifier : {editingResource?.title || ""}
                    </span>
                }
                footer={null}
                onCancel={() => {
                    setIsEditing(false);
                    setEditingResource(null);
                }}
                width="60%"
                destroyOnClose
            >
                <Form layout="vertical">
                    <Form.Item label="Titre" required>
                        <Input
                            value={editTitle}
                            onChange={(e) => setEditTitle(e.target.value)}
                            placeholder="Titre de la ressource"
                            prefix={<FileTextOutlined style={{ color: "#bfbfbf" }} />}
                            style={styles.linkInput}
                        />
                    </Form.Item>

                    <Form.Item label={
                        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <LinkOutlined style={{ color: "#1890ff" }} />
                            Lien (URL)
                        </span>
                    }>
                        <Input
                            value={editLink}
                            onChange={(e) => setEditLink(e.target.value)}
                            placeholder="https://exemple.com/documentation"
                            prefix={<GlobalOutlined style={{ color: "#bfbfbf" }} />}
                            style={styles.linkInput}
                        />
                        <div style={{ fontSize: "12px", color: "#8c8c8c", marginTop: "4px" }}>
                            L'étudiant verra le titre comme lien cliquable (ouverture nouvel onglet)
                        </div>
                    </Form.Item>

                    <div style={styles.editorToggle}>
                        <Switch
                            size="small"
                            checked={showEditEditor}
                            onChange={setShowEditEditor}
                        />
                        <span>Contenu supplémentaire (description, notes...)</span>
                    </div>

                    {showEditEditor && (
                        <Form.Item label="Contenu supplémentaire">
                            <Editor
                                apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                initialValue={editContent || ""}
                                onEditorChange={(v) => setEditContent(v)}
                                init={{
                                    height: 250,
                                    menubar: false,
                                    plugins: "link autolink lists",
                                    toolbar: "undo redo | bold italic | link | bullist numlist",
                                    link_default_target: "_blank",
                                }}
                            />
                        </Form.Item>
                    )}

                    <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        block
                        loading={savingEdit}
                        onClick={handleUpdate}
                        disabled={!editTitle.trim()}
                        style={{
                            borderRadius: "8px",
                            height: "42px",
                            background: "linear-gradient(135deg, #722ed1 0%, #531dab 100%)",
                            border: "none",
                        }}
                    >
                        Enregistrer les modifications
                    </Button>
                </Form>
            </Modal>
        </>
    );
};

export default ResourceManager;